import React, { useState } from 'react';

import { Button } from '@components/button';
import { TagSelectorSingle } from '@components/tag-selector/tag-selector';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useCurrentCompany } from 'api/authentication/hooks';
import { useEditCompanyDetails } from 'api/company/hooks';

import { PreboardingPage } from './common';

import { CompanyPreboardingStepper, useNextStep } from '../navigation';

const INDUSTRIES = [
  'Information Technology',
  'Financial Services',
  'Health Care',
  'Energy',
  'Marketing',
  'Aviation',
  'Communication',
  'Tourism & Hospitality',
  'Entertainment & Media',
  'Education',
  'Other',
];

export const CompanyIndustry = () => {
  const { t } = useScopedTranslate(locale);
  const [selected, setSelected] = useState('');
  const editMutation = useEditCompanyDetails({ shouldNotShowSuccess: true });
  const currentCompany = useCurrentCompany();
  const navigateToNextStep = useNextStep();

  const handleContinue = async () => {
    if (selected) {
      await editMutation.mutateAsync({ industry: selected });
    }
    navigateToNextStep();
  };

  return (
    <PreboardingPage>
      <Text text={t('title', { companyName: currentCompany?.name ?? '' })} font="heading1" center />
      <TagSelectorSingle
        options={INDUSTRIES}
        onChange={setSelected}
        defaultValue={currentCompany?.industry}
      />
      <Button
        variant="primary-blue"
        onClick={() => handleContinue()}
        isDisabled={!selected && !currentCompany?.industry}
      >
        {t('core.continue')}
      </Button>
      <CompanyPreboardingStepper />
    </PreboardingPage>
  );
};

const locale = {
  en: {
    title: 'What industry is {companyName} in?',
    companyName: 'Company name',
  },
};
